<template>
    <div v-if="productsTable.data.length>0" class="container">
        <vue-table-dynamic class="tableModifier" 
        :params="productsTable" 
        @row-click="onSelect"
        ref="tableProducts"
        >
        </vue-table-dynamic>
    </div>
    <Loading v-else/>
</template>
<script>
import VueTableDynamic from 'vue-table-dynamic';
import Loading from '@/components/parts/Loading.vue';
export default {
    name: 'Products',
    components: { VueTableDynamic, Loading },
    data() {
        return {
            productsTable: {
                data: this.$store.state.productsTable,
                header: 'row',
                enableSearch: true,
                pagination: true,
                pageSize: 25,
                pageSizes: [],
                sort: [0,2,5,6],
                maxWidth:2000,
            },
            tablehead: [['Support ID','Description','Status','Creation Date','Expires at','Product Category','Discount','Autorenew']],
        }
    },
    methods: {
        onSelect (index, data) {
            if(data[0]!='Support ID'){
                this.$router.push('/products/'+data[0]);
            }
        },
        getProducts: function(){
            var vue = this;
            this.$socket.client.emit('getProducts',null, (error, response) => {
                console.log()
                if(error=='200'){
                    vue.productsTable.data = vue.tablehead.concat(response.map(data => [data.supportid,data.description,data.status,data.creation,data.deletion,data.productid,data.discount+' %',data.autorenew]));
                    vue.$store.state.productsTable = vue.tablehead.concat(response.map(data => [data.supportid,data.description,data.status,data.creation,data.deletion,data.productid,data.discount+' %',data.autorenew]));
                }
            })
        }
    },
    mounted() {
        this.getProducts();
    },
}
</script>